const KEY = 'ai_usage';
const FREE_LIMIT = 3;

function getTodayStr() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
}

export function getAIUsageToday() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return 0;
    const { date, count } = JSON.parse(raw);
    return date === getTodayStr() ? count : 0;
  } catch { return 0; }
}

export function incrementAIUsage() {
  const today = getTodayStr();
  const count = getAIUsageToday() + 1;
  localStorage.setItem(KEY, JSON.stringify({ date: today, count }));
  return count;
}

export function getRemainingAI(isPro) {
  if (isPro) return Infinity;
  return Math.max(0, FREE_LIMIT - getAIUsageToday());
}

export function canUseAI(isPro) {
  if (isPro) return true;
  return getAIUsageToday() < FREE_LIMIT;
}

export { FREE_LIMIT };